// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaskNotifications-module__root___FbLQN {
  position: relative;
}

.TaskNotifications-module__bellButton___XtDOf {
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: #71717a;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
  position: relative;
}

.TaskNotifications-module__notificationBadge___ewZy2 {
  position: absolute;
  top: -2px;
  right: -4px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border: 2px solid #ffffff;
  border-radius: 999px;
  background: #ef4444;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  pointer-events: none;
}

.TaskNotifications-module__bellButton___XtDOf:hover {
  background: #f4f4f5;
  color: #18181b;
}

.TaskNotifications-module__bellButton___XtDOf:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskNotifications-module__bellIcon___V_qzd {
  width: 16px;
  height: 16px;
}

.TaskNotifications-module__dropdown___jNn9b {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  z-index: 30;
  width: 420px;
  max-width: calc(100vw - 32px);
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 10px;
  box-shadow: 0 18px 45px rgba(24, 24, 27, 0.14);
  overflow: hidden;
}

.TaskNotifications-module__header___Wwxj7 {
  padding: 12px 14px;
  border-bottom: 1px solid #e4e4e7;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.TaskNotifications-module__title___B7pDQ {
  font-size: 14px;
  font-weight: 600;
  color: #27272a;
}

.TaskNotifications-module__section___qkNeT {
  padding: 12px 14px;
  border-bottom: 1px solid #e4e4e7;
}

.TaskNotifications-module__channelRow___ANf_r {
  display: flex;
  gap: 8px;
  align-items: center;
}

.TaskNotifications-module__channelRow___ANf_r + .TaskNotifications-module__channelRow___ANf_r {
  margin-top: 8px;
}

.TaskNotifications-module__fieldLabel___snAEp {
  flex: 0 0 92px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  color: #52525b;
}

.TaskNotifications-module__inputContainer____PASc {
  flex: 1 1 auto;
  min-width: 0;
}

.TaskNotifications-module__slackInputGroup___MflS9 {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
}

.TaskNotifications-module__inputWrapper___Wx4DV {
  width: 100%;
  border: 1px solid #e4e4e7 !important;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: inset 0 1px 2px rgba(24, 24, 27, 0.03);
}

.TaskNotifications-module__inputWrapper___Wx4DV input {
  padding: 7px 10px !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 1.2 !important;
  color: #52525b !important;
}

.TaskNotifications-module__inputWrapper___Wx4DV input::placeholder {
  color: #a1a1aa !important;
  opacity: 1 !important;
}

.TaskNotifications-module__applyButton___nziKY {
  flex: 0 0 auto;
  min-width: 62px !important;
  padding: 6px 12px !important;
  border-radius: 8px !important;
  justify-content: center !important;
  align-self: center;
}

.TaskNotifications-module__applyButton___nziKY span {
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 1.2 !important;
}

.TaskNotifications-module__slackSearchResults___tmUD_ {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 16px 32px rgba(24, 24, 27, 0.12);
}

.TaskNotifications-module__slackSearchOption___PQe5s {
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 6px;
  background: transparent;
  text-align: left;
  cursor: pointer;
}

.TaskNotifications-module__slackSearchOption___PQe5s:hover {
  background: #f4f4f5;
}

.TaskNotifications-module__slackSearchPrimary___uMjRQ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #18181b;
}

.TaskNotifications-module__slackWorkspaceBadge___oVOTY {
  flex: 0 0 auto;
  padding: 1px 6px;
  border-radius: 999px;
  background: #f4f4f5;
  font-size: 10px;
  font-weight: 600;
  color: #71717a;
  text-transform: uppercase;
}

.TaskNotifications-module__slackSearchState___ijXPr {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 5;
  padding: 10px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 16px 32px rgba(24, 24, 27, 0.12);
  font-size: 12px;
  color: #71717a;
}

.TaskNotifications-module__matrix___Vc30p {
  display: grid;
  grid-template-columns: minmax(0, 1fr) repeat(4, 48px);
  align-items: center;
  row-gap: 8px;
  column-gap: 12px;
}

.TaskNotifications-module__matrixHeading___az4jd {
  font-size: 11px;
  font-weight: 600;
  color: #a1a1aa;
  letter-spacing: 0.04em;
}

.TaskNotifications-module__matrixIconCell___NGH9x {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a1a1aa;
}

.TaskNotifications-module__matrixIcon___kF2NF {
  width: 16px;
  height: 16px;
}

.TaskNotifications-module__categoryLabel___B2MUu {
  font-size: 14px;
  font-weight: 400;
  color: #52525b;
  line-height: 1.3;
}

.TaskNotifications-module__matrixSwitchCell___ZJ9TA {
  display: flex;
  align-items: center;
  justify-content: center;
}

.TaskNotifications-module__switch___jKLlV {
  width: 36px;
  height: 22px;
  border: none;
  border-radius: 999px;
  background: #e4e4e7;
  position: relative;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.TaskNotifications-module__switchChecked___mMaNl {
  background: #18181b;
}

.TaskNotifications-module__switchHandle___dn5aE {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(24, 24, 27, 0.18);
  transition: transform 0.15s ease;
}

.TaskNotifications-module__switchChecked___mMaNl .TaskNotifications-module__switchHandle___dn5aE {
  transform: translateX(14px);
}

.TaskNotifications-module__soundRow___lBigs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.TaskNotifications-module__soundLabel___if2rf {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 400;
  color: #52525b;
}

.TaskNotifications-module__soundIcon___lwQ7y {
  width: 14px;
  height: 14px;
}

.TaskNotifications-module__simulateButton___iUOKe {
  width: 100%;
  margin-top: 10px;
  padding: 0;
  border: none;
  background: transparent;
  font-size: 12px;
  font-weight: 500;
  color: #a1a1aa;
  text-align: center;
  cursor: default;
}

.TaskNotifications-module__feed___GzbO_ {
  min-height: 140px;
  max-height: 300px;
  overflow-y: auto;
  background: #ffffff;
}

.TaskNotifications-module__emptyState___y6DHk {
  padding: 44px 16px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #c4c4cc;
}

.TaskNotifications-module__notificationCard___avb3Y {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  padding: 12px 14px;
  border-bottom: 1px solid #f4f4f5;
  background: #ffffff;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.TaskNotifications-module__notificationCard___avb3Y:focus-visible {
  outline: 2px solid #93c5fd;
  outline-offset: -2px;
}

.TaskNotifications-module__notificationCardUnread___DDJO8 {
  background: #eff6ff;
}

.TaskNotifications-module__notificationCard___avb3Y:hover {
  background: #fafafa;
}

.TaskNotifications-module__notificationCardUnread___DDJO8:hover {
  background: #dbeafe;
}

.TaskNotifications-module__notificationDot___ytobE {
  width: 8px;
  height: 8px;
  margin-top: 6px;
  border-radius: 999px;
  flex: 0 0 auto;
}

.TaskNotifications-module__notificationContent___BhEmg {
  flex: 1 1 auto;
  min-width: 0;
}

.TaskNotifications-module__notificationHeaderRow___jTaSw {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.TaskNotifications-module__notificationTitleRow___KEFu4 {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.TaskNotifications-module__notificationMeta___g068_ {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.TaskNotifications-module__dismissButton___chX62 {
  width: 18px;
  height: 18px;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: #a1a1aa;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.TaskNotifications-module__dismissButton___chX62:hover {
  background: rgba(24, 24, 27, 0.06);
  color: #52525b;
}

.TaskNotifications-module__dismissButton___chX62:focus-visible {
  outline: 2px solid #93c5fd;
  outline-offset: 2px;
}

.TaskNotifications-module__dismissIcon___o2qU9 {
  width: 12px;
  height: 12px;
}

.TaskNotifications-module__notificationCategoryIcon___K4bng {
  width: 12px;
  height: 12px;
  color: #a1a1aa;
  flex: 0 0 auto;
}

.TaskNotifications-module__notificationTitle___HaLpB {
  font-size: 14px;
  font-weight: 500;
  color: #18181b;
  line-height: 1.25;
}

.TaskNotifications-module__notificationSubtitle___OTvLm {
  margin-top: 4px;
  font-size: 13px;
  font-weight: 400;
  color: #71717a;
  line-height: 1.35;
}

.TaskNotifications-module__notificationTime___gH3nA {
  font-size: 11px;
  font-weight: 400;
  color: #a1a1aa;
  white-space: nowrap;
}

@media (max-width: 640px) {
  .TaskNotifications-module__dropdown___jNn9b {
    right: -8px;
    width: min(420px, 100vw - 24px);
  }
  .TaskNotifications-module__channelRow___ANf_r {
    flex-direction: column;
    align-items: stretch;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/TaskNotifications/TaskNotifications.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yDACE;EAEF,kBAAA;AADF;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;AADF;;AAKA;EACE,mBAAA;EACA,cAAA;AAFF;;AAKA;EACE,0BAAA;EACA,mBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;AAFF;;AAKA;EACE,kBAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,8CAAA;EACA,gBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,kBAAA;EACA,gCAAA;AAFF;;AAKA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;EACA,YAAA;AAFF;;AAKA;EACE,kBAAA;EACA,cAAA;EACA,YAAA;AAFF;;AAKA;EACE,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,kDAAA;AAFF;;AAKA;EACE,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,yBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,qBAAA;AAFF;;AAKA;EACE,cAAA;EACA,0BAAA;EACA,4BAAA;EACA,6BAAA;EACA,kCAAA;EACA,kBAAA;AAFF;;AAKA;EACE,0BAAA;EACA,2BAAA;EACA,2BAAA;AAFF;;AAKA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8CAAA;AAFF;;AAKA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8CAAA;EACA,eAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,qDAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,uCAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;EACA,gCAAA;AAFF;;AAKA;EACE,2BAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;AAFF;;AAKA;EACE,WAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAFF;;AAKA;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAFF;;AAMA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,eAAA;EACA,uCAAA;AAHF;;AAMA;EACE,0BAAA;EACA,oBAAA;AAHF;;AAOA;EACE,mBAAA;AAJF;;AAOA;EACE,mBAAA;AAJF;;AAOA;EACE,mBAAA;AAJF;;AAOA;EACE,UAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;AAJF;;AAOA;EACE,cAAA;EACA,YAAA;AAJF;;AAOA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yDACE;AALJ;;AASA;EACE,kCAAA;EACA,cAAA;AANF;;AASA;EACE,0BAAA;EACA,mBAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;AANF;;AAWA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AARF;;AAWA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AARF;;AAWA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AARF;;AAWA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AARF;;AAYA;EACE;IACE,WAAA;IACA,+BAAA;EATF;EAYA;IACE,sBAAA;IACA,oBAAA;EAVF;AACF","sourcesContent":[".root {\n  position: relative;\n}\n\n.bellButton {\n  width: 28px;\n  height: 28px;\n  border: none;\n  border-radius: 999px;\n  background: transparent;\n  color: #71717a;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    color 0.15s ease;\n  position: relative;\n}\n\n.notificationBadge {\n  position: absolute;\n  top: -2px;\n  right: -4px;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  border: 2px solid #ffffff;\n  border-radius: 999px;\n  background: #ef4444;\n  color: #ffffff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1;\n  pointer-events: none;\n}\n\n\n.bellButton:hover {\n  background: #f4f4f5;\n  color: #18181b;\n}\n\n.bellButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.bellIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.dropdown {\n  position: absolute;\n  top: calc(100% + 10px);\n  right: 0;\n  z-index: 30;\n  width: 420px;\n  max-width: calc(100vw - 32px);\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 10px;\n  box-shadow: 0 18px 45px rgba(24, 24, 27, 0.14);\n  overflow: hidden;\n}\n\n.header {\n  padding: 12px 14px;\n  border-bottom: 1px solid #e4e4e7;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #27272a;\n}\n\n.section {\n  padding: 12px 14px;\n  border-bottom: 1px solid #e4e4e7;\n}\n\n.channelRow {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.channelRow + .channelRow {\n  margin-top: 8px;\n}\n\n.fieldLabel {\n  flex: 0 0 92px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.2;\n  color: #52525b;\n}\n\n.inputContainer {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.slackInputGroup {\n  position: relative;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.inputWrapper {\n  width: 100%;\n  border: 1px solid #e4e4e7 !important;\n  border-radius: 8px;\n  background: #ffffff;\n  box-shadow: inset 0 1px 2px rgba(24, 24, 27, 0.03);\n}\n\n.inputWrapper :global(input) {\n  padding: 7px 10px !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  line-height: 1.2 !important;\n  color: #52525b !important;\n}\n\n.inputWrapper :global(input::placeholder) {\n  color: #a1a1aa !important;\n  opacity: 1 !important;\n}\n\n.applyButton {\n  flex: 0 0 auto;\n  min-width: 62px !important;\n  padding: 6px 12px !important;\n  border-radius: 8px !important;\n  justify-content: center !important;\n  align-self: center;\n}\n\n.applyButton span {\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  line-height: 1.2 !important;\n}\n\n.slackSearchResults {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  z-index: 5;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 6px;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  background: #ffffff;\n  box-shadow: 0 16px 32px rgba(24, 24, 27, 0.12);\n}\n\n.slackSearchOption {\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n}\n\n.slackSearchOption:hover {\n  background: #f4f4f5;\n}\n\n.slackSearchPrimary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.slackWorkspaceBadge {\n  flex: 0 0 auto;\n  padding: 1px 6px;\n  border-radius: 999px;\n  background: #f4f4f5;\n  font-size: 10px;\n  font-weight: 600;\n  color: #71717a;\n  text-transform: uppercase;\n}\n\n.slackSearchState {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  z-index: 5;\n  padding: 10px;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  background: #ffffff;\n  box-shadow: 0 16px 32px rgba(24, 24, 27, 0.12);\n  font-size: 12px;\n  color: #71717a;\n}\n\n.matrix {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) repeat(4, 48px);\n  align-items: center;\n  row-gap: 8px;\n  column-gap: 12px;\n}\n\n.matrixHeading {\n  font-size: 11px;\n  font-weight: 600;\n  color: #a1a1aa;\n  letter-spacing: 0.04em;\n}\n\n.matrixIconCell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #a1a1aa;\n}\n\n.matrixIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.categoryLabel {\n  font-size: 14px;\n  font-weight: 400;\n  color: #52525b;\n  line-height: 1.3;\n}\n\n.matrixSwitchCell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.switch {\n  width: 36px;\n  height: 22px;\n  border: none;\n  border-radius: 999px;\n  background: #e4e4e7;\n  position: relative;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.switchChecked {\n  background: #18181b;\n}\n\n.switchHandle {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #ffffff;\n  box-shadow: 0 1px 4px rgba(24, 24, 27, 0.18);\n  transition: transform 0.15s ease;\n}\n\n.switchChecked .switchHandle {\n  transform: translateX(14px);\n}\n\n.soundRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.soundLabel {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #52525b;\n}\n\n.soundIcon {\n  width: 14px;\n  height: 14px;\n}\n\n.simulateButton {\n  width: 100%;\n  margin-top: 10px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  font-size: 12px;\n  font-weight: 500;\n  color: #a1a1aa;\n  text-align: center;\n  cursor: default;\n}\n\n.feed {\n  min-height: 140px;\n  max-height: 300px;\n  overflow-y: auto;\n  background: #ffffff;\n}\n\n\n.emptyState {\n  padding: 44px 16px;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 400;\n  color: #c4c4cc;\n}\n\n.notificationCard {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  width: 100%;\n  padding: 12px 14px;\n  border-bottom: 1px solid #f4f4f5;\n  background: #ffffff;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.notificationCard:focus-visible {\n  outline: 2px solid #93c5fd;\n  outline-offset: -2px;\n}\n\n\n.notificationCardUnread {\n  background: #eff6ff;\n}\n\n.notificationCard:hover {\n  background: #fafafa;\n}\n\n.notificationCardUnread:hover {\n  background: #dbeafe;\n}\n\n.notificationDot {\n  width: 8px;\n  height: 8px;\n  margin-top: 6px;\n  border-radius: 999px;\n  flex: 0 0 auto;\n}\n\n.notificationContent {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.notificationHeaderRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.notificationTitleRow {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.notificationMeta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 0 0 auto;\n}\n\n.dismissButton {\n  width: 18px;\n  height: 18px;\n  border: none;\n  border-radius: 999px;\n  background: transparent;\n  color: #a1a1aa;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.dismissButton:hover {\n  background: rgba(24, 24, 27, 0.06);\n  color: #52525b;\n}\n\n.dismissButton:focus-visible {\n  outline: 2px solid #93c5fd;\n  outline-offset: 2px;\n}\n\n.dismissIcon {\n  width: 12px;\n  height: 12px;\n}\n\n\n\n.notificationCategoryIcon {\n  width: 12px;\n  height: 12px;\n  color: #a1a1aa;\n  flex: 0 0 auto;\n}\n\n.notificationTitle {\n  font-size: 14px;\n  font-weight: 500;\n  color: #18181b;\n  line-height: 1.25;\n}\n\n.notificationSubtitle {\n  margin-top: 4px;\n  font-size: 13px;\n  font-weight: 400;\n  color: #71717a;\n  line-height: 1.35;\n}\n\n.notificationTime {\n  font-size: 11px;\n  font-weight: 400;\n  color: #a1a1aa;\n  white-space: nowrap;\n}\n\n\n@media (max-width: 640px) {\n  .dropdown {\n    right: -8px;\n    width: min(420px, calc(100vw - 24px));\n  }\n\n  .channelRow {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `TaskNotifications-module__root___FbLQN`,
	"bellButton": `TaskNotifications-module__bellButton___XtDOf`,
	"notificationBadge": `TaskNotifications-module__notificationBadge___ewZy2`,
	"bellIcon": `TaskNotifications-module__bellIcon___V_qzd`,
	"dropdown": `TaskNotifications-module__dropdown___jNn9b`,
	"header": `TaskNotifications-module__header___Wwxj7`,
	"title": `TaskNotifications-module__title___B7pDQ`,
	"section": `TaskNotifications-module__section___qkNeT`,
	"channelRow": `TaskNotifications-module__channelRow___ANf_r`,
	"fieldLabel": `TaskNotifications-module__fieldLabel___snAEp`,
	"inputContainer": `TaskNotifications-module__inputContainer____PASc`,
	"slackInputGroup": `TaskNotifications-module__slackInputGroup___MflS9`,
	"inputWrapper": `TaskNotifications-module__inputWrapper___Wx4DV`,
	"applyButton": `TaskNotifications-module__applyButton___nziKY`,
	"slackSearchResults": `TaskNotifications-module__slackSearchResults___tmUD_`,
	"slackSearchOption": `TaskNotifications-module__slackSearchOption___PQe5s`,
	"slackSearchPrimary": `TaskNotifications-module__slackSearchPrimary___uMjRQ`,
	"slackWorkspaceBadge": `TaskNotifications-module__slackWorkspaceBadge___oVOTY`,
	"slackSearchState": `TaskNotifications-module__slackSearchState___ijXPr`,
	"matrix": `TaskNotifications-module__matrix___Vc30p`,
	"matrixHeading": `TaskNotifications-module__matrixHeading___az4jd`,
	"matrixIconCell": `TaskNotifications-module__matrixIconCell___NGH9x`,
	"matrixIcon": `TaskNotifications-module__matrixIcon___kF2NF`,
	"categoryLabel": `TaskNotifications-module__categoryLabel___B2MUu`,
	"matrixSwitchCell": `TaskNotifications-module__matrixSwitchCell___ZJ9TA`,
	"switch": `TaskNotifications-module__switch___jKLlV`,
	"switchChecked": `TaskNotifications-module__switchChecked___mMaNl`,
	"switchHandle": `TaskNotifications-module__switchHandle___dn5aE`,
	"soundRow": `TaskNotifications-module__soundRow___lBigs`,
	"soundLabel": `TaskNotifications-module__soundLabel___if2rf`,
	"soundIcon": `TaskNotifications-module__soundIcon___lwQ7y`,
	"simulateButton": `TaskNotifications-module__simulateButton___iUOKe`,
	"feed": `TaskNotifications-module__feed___GzbO_`,
	"emptyState": `TaskNotifications-module__emptyState___y6DHk`,
	"notificationCard": `TaskNotifications-module__notificationCard___avb3Y`,
	"notificationCardUnread": `TaskNotifications-module__notificationCardUnread___DDJO8`,
	"notificationDot": `TaskNotifications-module__notificationDot___ytobE`,
	"notificationContent": `TaskNotifications-module__notificationContent___BhEmg`,
	"notificationHeaderRow": `TaskNotifications-module__notificationHeaderRow___jTaSw`,
	"notificationTitleRow": `TaskNotifications-module__notificationTitleRow___KEFu4`,
	"notificationMeta": `TaskNotifications-module__notificationMeta___g068_`,
	"dismissButton": `TaskNotifications-module__dismissButton___chX62`,
	"dismissIcon": `TaskNotifications-module__dismissIcon___o2qU9`,
	"notificationCategoryIcon": `TaskNotifications-module__notificationCategoryIcon___K4bng`,
	"notificationTitle": `TaskNotifications-module__notificationTitle___HaLpB`,
	"notificationSubtitle": `TaskNotifications-module__notificationSubtitle___OTvLm`,
	"notificationTime": `TaskNotifications-module__notificationTime___gH3nA`
};
module.exports = ___CSS_LOADER_EXPORT___;
